<template>
	<div class="container">
		<div class="content">
			<section>
				<div class="sub_content1 d_flex justify_center align_items_center">
					<h2 class="title">
						{{ $t('cs.title') }}
					</h2>
				</div>
			</section>

			<div class="border_bottom">
				<ul class="tab_area">
					<li
						v-for="(tabInfo, idx) in tabs"
						:key="tabInfo.type"
						:class="{ selected: selectedTabIdx === idx }"
					>
						<a class="tab_item" @click="tabSelect(idx)">
							<span>{{ $t(tabInfo.lang_code) }}</span></a
						>
					</li>
				</ul>
			</div>
			<div class="tap_wrap">
				<component :is="tabs[selectedTabIdx].type"></component>
			</div>
		</div>
		<div class="bottom d_flex justify_center">
			<div class="d_flex mr_40">
				<p>{{ $t('banner2.text1') }}</p>
				<span>10:00 - 19:00 {{ $t('banner2.text2') }} </span>
			</div>
			<div class="d_flex mr_40">
				<p>{{ $t('banner2.text3') }}</p>
				<span>{{ $t('banner2.text4') }}{{ $t('banner2.text5') }}</span>
			</div>
			<div class="d_flex">
				<p>{{ $t('banner2.text6') }}</p>
				<span>10:00 - 19:00 {{ $t('banner2.text7') }} </span>
			</div>
		</div>
	</div>
</template>

<script>
import Notice from '@/components/Service/Cs/Notice';
import Inquiry from '@/components/Service/Cs/Inquiry';
import InquiryDetail from '@/components/Service/Cs/InquiryDetail';
import Faq from '@/components/Service/Cs/Faq';
import { fetchFaqList, fetchTicketTypes } from '@/api/cs';
import { commonError } from '@/common/dialog';

export default {
	name: 'Cs',
	components: {
		Notice,
		Inquiry,
		InquiryDetail,
		Faq,
	},
	data() {
		return {
			selectedTab: 1,
			isWrite: true,
			faqList: [],
			faqTypeList: [],
			inquiryList: [],
			noticeList: [],
			pageNavigation: {},
			curPage: 1,
			listCount: 10,

			parent_seq: '',
			type_seq: '',
			title: '',
			content: '',
			email_address: '',
			password: '',
			field_values: [],
			ticket_type_list: [],
			ticket_id: '',
			selectedTabIdx: 0,
			tabs: [
				{
					type: 'notice',
					lang_code: 'cs.notice',
				},
				{
					type: 'inquiry',
					lang_code: 'cs.inquiry.inquiry',
				},
				{
					type: 'InquiryDetail',
					lang_code: 'cs.inquiry.list',
				},
				{
					type: 'faq',
					lang_code: 'cs.faq',
				},
			],
		};
	},
	created() {
		this.init2();
		this.init3();
	},
	methods: {
		tabSelect(idx) {
			this.selectedTabIdx = idx;
		},
		init() {
			Promise.all([this.loadFaqTypeList()]).then(() => {
				this.loadNoticeList();
			});
		},

		init2() {
			this.loadFaqList();
		},
		init3() {
			this.loadTicketTypeList();
		},
		async loadFaqList() {
			const params = {
				page: this.curPage,
				list_count: this.listCount,
			};
			const { data, page_navigation } = await fetchFaqList(params).catch(
				commonError,
			);
			this.faqList = data;
			this.pageNavigation = page_navigation;
		},
		async loadTicketTypeList() {
			const { data } = await fetchTicketTypes().catch(commonError);
			this.ticket_type_list = data;
		},

		goList() {
			this.selectedTab = 3;
		},
	},
};
</script>

<style scoped>
.rtr_cs .tab_area {
	width: 1200px;
	margin: 0 auto;
}
.rtr_cs .border_bottom {
	border-bottom: 1px solid #ddd;
}

.rtr_cs .tab_area li a {
	padding: 30px 25px;
}
.rtr_cs .container {
	padding: 69px 0 0;
}
.rtr_cs .content {
	width: 100%;
}
.rtr_cs section .title {
	margin-bottom: 30px;
	font-size: 36px;
	line-height: 1.2;
	letter-spacing: -1.8px;
}
.rtr_cs section .text {
	font-size: 20px;
	font-weight: 300;
	line-height: 1.33;
	letter-spacing: -0.38px;
}
.rtr_cs .sub_content1 {
	width: 100%;
	height: 230px;
	margin: 0 auto;
	background: #1e1e1e;
	color: #fff;
}
.rtr_cs .sub_content1 {
	background: url('~@/assets/images/sub/cs.png') #000;
	background-size: cover;
}
.rtr_cs .tap_wrap {
	padding: 70px 0;
	width: 1200px;
	margin: 0 auto;
}
.notice_no {
	border-bottom: 1px solid #ddd;
}
.notice_no p {
	padding: 20px 0;
	text-align: center;
	font-size: 16px;
}
.rtr_cs .bottom {
	position: absolute;
	bottom: 0;
	width: 100%;
	padding: 15px 0;
	background: #f0f0f0;
}
.rtr_cs .bottom p {
	margin-right: 10px;
	font-size: 15px;
	font-weight: 600;
}
.rtr_cs .bottom span {
	font-size: 15px;
	font-weight: 300;
}
.mr_40 {
	margin-right: 40px;
}
</style>
